import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">A Sense of Convenience</p>
        <p className="chapter__paragraph">
          Miller’s Landing residents will see screens of all shapes and sizes throughout the town,
          from lobbies to outdoor event spaces, all designed to enhance the user experience. Screens
          will project dynamic advertising and help with wayfinding on the property—including
          recommendation engines to support conveniences like booking restaurant reservations. But
          when it comes to the info being collected, creating community and comfort is the overall
          mission. The screens’ purpose is to improve the user experience, so Miller’s Landing will
          be transparent about data capture, usage, and governance.
        </p>
        <p className="chapter__paragraph">
          Figuring out how to seamlessly embed and integrate this multitude of screens is one
          challenge Intel is addressing. But the solution will pay off for users when those screens
          can connect seamlessly with their smartphones and work with features of the mobile app.
        </p>
        <p className="chapter__paragraph">
          This attention to the smartphone is a key focus for Miller’s Landing. “If we can generate
          adoption of a branded mobile application, it will not only be the interface for goods and
          services within the property and beyond, it will also be the primary communication channel
          for programming and events,” Wilkinson says. Going back to the restaurant example: On a
          night with below-average reservations booked, a notification can be delivered announcing a
          special chef’s tasting menu or demonstration to increase sittings.
        </p>
        <p className="chapter__paragraph">
          When it comes to the design of the video technology at Miller’s Landing, the goal is to
          maintain the overall design aesthetic of the area rather than create a “futuristic” look.
          Castle Rock is an old frontier town with a railroad history that Miller’s Landing intends
          to honor.
        </p>
      </section>
    </>
  );
}

export default Chapter5;
